import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, lastValueFrom } from 'rxjs';
import { ReadMeComponent } from 'src/app/popup/read-me/read-me.component';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { MenuManagementService } from '../services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';
import { ErrorLogsDisplayComponent } from 'src/app/popup/error-logs-display/error-logs-display.component';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ErrorLog } from 'src/app/models/errorLog';
import { UtilsService } from 'src/app/services/utils.service';
import { SelfTrainingToolService } from 'src/app/services/self-training-tool.service';
import { UserSupportTicketComponent } from 'src/app/popup/user-support-ticket/user-support-ticket.component';
import { SupportTicketsComponent } from 'src/app/popup/support-tickets/support-tickets.component';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss'],
  standalone: false
})
export class HelpMenuComponent implements OnInit {

  readonly preReleaseToolEnabled = environment.enablePreReleaseTools;

  constructor(public menuService: MenuManagementService,
    private endpointService : EndpointsService,
    private http: HttpClient,
    private modalService : BsModalService,
    private tabsService: TabsService,
    private messageModalService: ModalControlService,
    private selfTrainingToolService: SelfTrainingToolService) {

  }

  ngOnInit(): void {
  }

  async openDemeterXwiki() {

    const loginInfo: string[] = await this.selfTrainingToolService.getLoginInfo();

    /*const headers = new HttpHeaders({
      Authorization: 'Basic ' + btoa(`${loginInfo[1]}:${loginInfo[2]}`),
      //'Content-Type': 'application/json'
    });*/

    await lastValueFrom(this.http.get<any>(`${loginInfo[0]}rest/wikis/xwiki`/*, { headers }*/));
    window.open(loginInfo[0] + "/bin/view/DEMETER%20WIKI/", '_blank');
  }

  downloadPDF() : Observable<Blob>{
    const url = this.endpointService.apiUrlConfiguration + "/usermanual";

    return this.http.get<Blob>(url, {
      headers : this.endpointService.httpOptions.headers,
      responseType: 'blob' as 'json'
    })
  }

  clickDownloadpdf() : any{
    this.downloadPDF().subscribe(res => {
      let file = res;
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_blank');
    });
  }

  openReadMeModal(){
    const bsRef:BsModalRef = this.modalService.show(ReadMeComponent);
    bsRef.content.title = "Read Me";
  }

  openAboutDemeterModal(){
    const bsRef:BsModalRef = this.modalService.show(ReadMeComponent);
    bsRef.content.title = "About Grit";
  }

  openSelfTrainingTool(){
    this.tabsService.openNewToolsTab(TabsService.SELF_TRAINING_TOOL);
  }



  openMyTickets(): void {
    if (!this.preReleaseToolEnabled) {
      return;
    }

  this.messageModalService.openSupportTickets();

}

  openErrorLogs(){
    this.getAllErrorLogsRequest().subscribe({
      next: (errorLogs: ErrorLog[]) => {
        if (errorLogs && errorLogs.length == 0){
          this.messageModalService.showMesssageModal("Error Logs", "Currently, there are no Error Logs.");
          return;
        }
        const errorLogsByCalcType: Map<String, ErrorLog[]> = new Map();
        for (const errorLog of errorLogs){
          if (!errorLogsByCalcType.has(errorLog.calcType)){
            errorLogsByCalcType.set(errorLog.calcType, []);
          }
          errorLogsByCalcType.get(errorLog.calcType).push(errorLog);
        }
        const bsRef:BsModalRef = this.modalService.show(ErrorLogsDisplayComponent, {
          backdrop: 'static' // Prevent closing on backdrop click
        });
        bsRef.content.errorLogsByCalcType = errorLogsByCalcType;
      },
      error: error => {
        this.messageModalService.showMesssageModal("Error", "There was an error fetching Error Logs.");
      }
    })
  }

  getAllErrorLogsRequest(){
    return this.http.get<ErrorLog[]>(this.endpointService.getAllErrorLogs, this.endpointService.httpOptions);
  }


  getIsAdminFromJwtToken(){
    const rolesToken = this.endpointService.getUserRolesToken();
    return rolesToken ? UtilsService.getIsAdminFromJwtToken(rolesToken) : false;
  }


  openNewTicket(){
    if (!this.preReleaseToolEnabled) {
      return;
    }

    this.modalService.show(UserSupportTicketComponent, {
      backdrop: 'static'
    });

  }

}
